import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
const CasinoPage = lazy(() => import('src/pages/dashboard/casino'));
// PRODUCT
// ORDER
// INVOICE
// USER
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
// BLOG
// JOB
// TOUR
// FILE MANAGER
// APP
// TEST RENDER PAGE BY ROLE
// BLANK PAGE

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'config',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'games', element: <CasinoPage /> },
      {
        path: 'user',
        children: [
          { element: <UserAccountPage />, index: true },
          { path: 'account', element: <UserAccountPage /> },
        ],
      },
    ],
  },
];
